import { getProductView_productDetailByMasterId } from '@containers/ProductDetailContainer/queries/__generated__/getProductView';

export const getProductFullName = (
  product: getProductView_productDetailByMasterId
): string =>
  [
    product.brandInfo && product.brandInfo.name,
    product.collection,
    product.subName,
  ]
    .filter(Boolean)
    .join(' ');
